import { ICommand } from 'core-ts-types';
import { Major } from './../../builders/major_builder';

export class SuggestedMajorsController {
  majors: Major[];
  maxMajorsSelected: boolean;
  isRequestPending = true;

  constructor(
    private $scope: ng.IScope,
    private $element: ng.IRootElementService,
    private $timeout: ng.ITimeoutService,
    private loadTransferSuggestedMajorsCommand: ICommand,
    private selectTransferMajorCommand: ICommand
  ) {
    this.loadTransferSuggestedMajorsCommand().then(() => {
      this.isRequestPending = false;
    });
  }

  hasMajors(): boolean {
    return !_.isEmpty(this.majors);
  }

  areAllSelected(): boolean {
    return this.hasMajors() && _.every(this.majors, (major) => major.isSelected);
  }

  gotResults(): boolean {
    return !this.isRequestPending && this.hasMajors();
  }

  gotEmptyResults(): boolean {
    return !this.isRequestPending && !this.hasMajors();
  }

  writeDegreeCompletion(major: Major): string {
    return `${Math.round(major.degree_completion_percent!)}% degree completion`;
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngSuggestedMajorsController', SuggestedMajorsController)
  .component('suggestedMajors', {
    controller: 'ngSuggestedMajorsController',
    templateUrl: 'lib/transfer/components/suggested_majors/suggested_majors.html',
    controllerAs: '$ctrl',
    bindings: {
      majors: '<',
      maxMajorsSelected: '<?'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/suggested_majors/suggested_majors.ts